import { createFileRoute } from "@tanstack/react-router";

import { LandingPage } from "@/components/marketing/landing-page";
import { pageHead, softwareApplicationJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/(public)/")({
  head: () => pageHead("home", { jsonLd: softwareApplicationJsonLd() }),
  component: LandingPage,
});
